import { PageFrame } from "../../components/page_frame";
import { InventoryHealthWithTransfersContainer } from "./container";

export default function InventoryHealthWithTransfersPage() {
  return (
    <PageFrame>
      <InventoryHealthWithTransfersContainer />
    </PageFrame>
  );
}
